import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import {
    ISelect,
    ParamEnum,
    PERSON_TYPE_JURIDICAL,
} from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import {
    asyncGetParamByCode,
    asyncGetParams,
} from '../../../../../../services/param.service';
import { AccountContactPerson } from '../../../../../../shared/types/modules/account';
import { AccountContactPersonProps } from './props';

export const useAccountContactPerson = ({
    data,
    onChangeData,
    onChangeFormik,
}: AccountContactPersonProps) => {
    const [typesDocument, setTypesDocument] = useState<ISelect[]>([]);
    const [genders, setGenders] = useState<ISelect[]>([]);
    const [typesPerson, setTypesPerson] = useState<ISelect[]>([]);
    const [juridical, setJuridical] = useState<ISelect>();

    const onSubmit = (data: AccountContactPerson) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(juridical?.id?.toString()),
        onSubmit,
    });

    const isJuridical = formik.values.personType === juridical?.id;
    const gendersFiltered = isJuridical
        ? genders.filter((g) => g.code === `${ParamEnum.GENDER}_10`)
        : genders.filter((g) => g.code !== `${ParamEnum.GENDER}_10`);

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        if (isJuridical) {
            formik?.setFieldValue('gender', gendersFiltered[0]?.id);
        }
    }, [formik.values.personType]);

    useEffect(() => {
        if (isJuridical) formik?.setFieldValue('lastName', '');
    }, [isJuridical]);

    useEffect(() => {
        formik?.setFieldValue('document', data?.document || '');
        formik?.setFieldValue('personType', data?.personType || '');
        formik?.setFieldValue('typeDocument', data?.typeDocument || '');
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('lastName', data?.lastName || '');
        formik?.setFieldValue('gender', data?.gender || '');
        formik?.setFieldValue('isLGBTIQ', data?.isLGBTIQ || false);
        formik?.setFieldValue('cellPhone', data?.cellPhone || '');
        formik?.setFieldValue('phone', data?.phone || '');
        formik?.setFieldValue('email', data?.email || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.DOCUMENT_TYPE).then((params) =>
            setTypesDocument(params)
        );
        asyncGetParams(ParamEnum.GENDER).then((params) => setGenders(params));
        asyncGetParams(ParamEnum.PERSON_TYPE).then((params) =>
            setTypesPerson(params)
        );
        asyncGetParamByCode(PERSON_TYPE_JURIDICAL).then((param) =>
            setJuridical(param)
        );
        asyncGetParams(ParamEnum.GENDER).then((params) => {
            setGenders(params);
        });
    }, []);

    return {
        formik,
        typesDocument,
        genders: gendersFiltered,
        typesPerson,
        juridical,
        isJuridical,
    };
};
